import store from '../../init/store.js'
import {getAllCombatantsOfTeam} from './team-utilities'

/** Return if either team is all the way dead */
export function getDeadTeams(useCombatants=null) {

  //Default to store, but allow user to pass in combatants object (for theoretical calculation)
  const allCombatants = useCombatants || store.getState().battle.combatants;

  const isTeamOneDead = getAllCombatantsOfTeam("one", allCombatants).every(comb => {
    return !comb.isAlive()
  });

  const isTeamTwoDead = getAllCombatantsOfTeam("two", allCombatants).every(comb => {
    return !comb.isAlive()
  });

  return [
    isTeamOneDead ? "one" : null,
    isTeamTwoDead ? "two" : null
  ].filter(d => Boolean(d))
}


//Return if one team is completely dead
//Slight abstraction of `getDeadTeams`
export function isBattleOver(useCombatants=null) {

  //Default to store, but allow user to pass in combatants object (for theoretical calculation)
  const combatants = useCombatants || store.getState().battle.combatants;

  //Return if one team is completely dead
  return getDeadTeams(combatants).length > 0;
}


export function getWinningTeam() {
  //Hardcoded to two teams
  const deadTeams = getDeadTeams();
  return ["one","two"].filter(teamId => !deadTeams.includes(teamId))[0] || "bothTeamsDead";
  //Return the first entry of one,two that is NOT included in deadTeams
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/get-dead-teams.js